import axios from "axios";


/*const base_url = 'http://192.168.43.126:8000/api/'*/
/*const base_url = 'http://localhost:8000/api/'*/
const base_url = 'http://kopakwetu.co.tz:8007/api/'


export default  class  API {
    static ax = axios // tukiika API.ax mean tumeita na configurations zote
}

//huku ni configuration tu za axios

axios.defaults.baseURL = base_url
axios.defaults.headers.common['Authorization']='Kizingiti '+sessionStorage.getItem("access") //after kizingiti{Barrier}kuna gep
axios.defaults.timeout.valueOf(86400000)
axios.interceptors.request.use(config=>{
    const source = axios.CancelToken.source();
    config.cancelToken = source.token;
    setTimeout(()=>source.cancel('Timed out after 30s'), 86400000);
    return config;
});

/*
import axios from "axios";
;

/!*const base_url = 'http://127.0.0.1:8000/api/';*!/
const base_url = 'http://localhost:8000/api/';

// Set the base URL for all Axios requests
axios.defaults.baseURL = base_url;

// Set the authorization header with the access token from sessionStorage
axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem("access");

// Set a global timeout for all requests (86400000 milliseconds = 24 hours)
axios.defaults.timeout = 86400000;

// Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    // Handle successful responses here
    const statusCode = response.status;
   /!* console.log('Response status code:', statusCode);*!/

    // Return the response object to be handled by the calling code
    return response;
  },
  (error) => {
    // Handle errors here
    if (error.response) {
      // Error response received from the server
      const statusCode = error.response.status;

      /!*sessionStorage.clear();
        window.location.reload();*!/
        /!*const data = {
            "refresh": sessionStorage.getItem('refresh')
        }
        AuthService.loginRefresh(data).then(r=>{
            console.log(r.data)
             sessionStorage.setItem('access', r.data.access);
            window.location.reload()
        })*!/

      console.error('Error status code:', statusCode);
    } else {
      // Request was not even sent or failed to reach the server (e.g., network error)

      console.error('Error:', error.message);
    }

    // Return a rejected Promise with the error object to be handled by the calling code
    return Promise.reject(error);
  }
);

export default class API {
  static ax = axios; // Tukiika API.ax mean tumeita na configurations zote
}
*/
